var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"animated fadeIn"},[(_vm.$beplugins.HasRoles(['Ansvarig', 'Administrator', 'Admin']))?_c('ProductNew'):_c('NotAuthorized')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }